import { UIViewSpec } from './view';

export function uiRegisterAnchor(where: UIViewSpec, name: string) {
    const elem = where.ui_elem;
    elem.classList.add('x-anchor');
    elem.ui_anchor_name = name;
}

export function uiScrollToAnchor(name: string) {
    for(const elem of document.querySelectorAll('.x-anchor')) {
        if(elem.ui_anchor_name == name) {
            elem.scrollIntoView({ behavior: 'smooth' });
            return;
        }
    }
}
